import React from 'react';
import { styled } from '@mui/material/styles';
import { Grid } from '@mui/material';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Box from '@mui/material/Box';
import dateToString from '../../helpers/dateToString';
import { useTheme } from '@mui/material';

import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

function MonthRangeSelect(props) {

    const {
        fromDate,
        untilDate,
        handleFromDateChange,
        handleUntilDateChange,
        required,
        minDateFrom,
        maxDateFrom,
        minDateUntil,
        maxDateUntil,
    } = props;
    const theme = useTheme();

    var requiredAsterisk = null;
    if (required) {
        requiredAsterisk = <Box color="error.main"> *</Box>;
    }
    
    var minDateFromString = dateToString(minDateFrom);
    var maxDateFromString = dateToString(maxDateFrom);

    var minDateUntilString = dateToString(minDateUntil);
    var maxDateUntilString = dateToString(maxDateUntil);

    var untilColor = untilDate === null ? theme.palette.filter.main: theme.palette.filter.secondary;
    var fromColor = fromDate === null ? theme.palette.filter.main: theme.palette.filter.secondary;

    return (
        <div>
            <Typography component={'div'} sx={{fontSize: theme.typography.pxToRem(14)}}>
                <div style={{ display: "flex" }}>
                    Escoge un rango de meses {requiredAsterisk}
                </div>
            </Typography>
                <Grid container spacing={1} >
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <Grid item xs={6}>
                        <DatePicker
                            disableToolbar
                            autoOk
                            format="MM/yyyy"
                            margin="normal"
                            id="date-picker-inline"
                            label={<Typography color={fromColor}>Desde</Typography>}
                            locale='es-ES'
                            value={fromDate}
                            onChange={handleFromDateChange}
                            InputLabelProps={{
                                shrink: true,
                              }}
                            KeyboardButtonProps={{
                                'aria-label': 'change date',
                            }}
                            minDate={minDateFrom}
                            maxDate={maxDateFrom}
                            minDateMessage={"La fecha debe ser después de la fecha mínima: " + minDateFromString}
                            maxDateMessage={"La fecha debe ser antes de la fecha máxima: " + maxDateFromString}
                            openTo="year"
                            views={["year","month"]}
                            invalidDateMessage={"Formato de fecha inválido."}
                            slotProps={{ 
                                textField: { 
                                    variant: 'standard'
                                }, 
                            }}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <DatePicker
                            locale='es-ES'
                            disableToolbar
                            autoOk
                            format="MM/yyyy"
                            margin="normal"
                            id="date-picker-inline"
                            InputLabelProps={{
                                shrink: true,
                              }}
                            label={<Typography color={untilColor}>Hasta</Typography>}
                            value={untilDate}
                            onChange={handleUntilDateChange}
                            KeyboardButtonProps={{
                                'aria-label': 'change date',
                            }}
                            minDate={minDateUntil}
                            maxDate={maxDateUntil}
                            minDateMessage={"La fecha debe ser después de la fecha seleccionada en ''Desde'': " + minDateUntilString}
                            maxDateMessage={"La fecha debe ser antes de la fecha máxima: " + maxDateUntilString}
                            openTo="year"
                            views={["year","month"]}
                            invalidDateMessage={"Formato de fecha inválido."}
                            slotProps={{ 
                                textField: { 
                                    variant: 'standard'
                                } 
                            }}
                        />
                    </Grid>
                    </LocalizationProvider>
                </Grid>
        </div>
    );
}

function MonthRangeSelectItem(props) {
    return (
        <div>
            <ListItem>
                <ListItemText primary={
                    <MonthRangeSelect
                        {...props}
                    />
                } />
            </ListItem>
            <Divider />
        </div>
    )
}

export default MonthRangeSelectItem;